module.exports = __webpack_public_path__ + "img/Signup side object.ab99bd48.png";